import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import BlogPost from "../components/Blog/BlogPost";
import SEO from "../components/common/SEO";
import { getPostById } from "../data/blogPosts";

const BlogPostPage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  
  // Get the post by slug/ID
  const post = getPostById(slug);

  const handleBackToList = () => {
    navigate("/blog");
  };

  if (!post) {
    // Post not found - redirect to 404 or blog listing
    navigate("/blog", { replace: true });
    return null;
  }

  // Individual blog post structured data
  const blogPostStructuredData = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": post.title,
    "description": post.excerpt,
    "image": post.image || "https://mihirshah.tech/og-image.jpg",
    "author": {
      "@type": "Person",
      "name": post.author || "Mihir Shah",
      "url": "https://mihirshah.tech",
      "sameAs": [
        "https://github.com/mihir-shah99",
        "https://linkedin.com/in/mihir-shah99",
        "https://x.com/mihirshah99"
      ]
    },
    "publisher": {
      "@type": "Organization",
      "name": "Mihir Shah",
      "logo": {
        "@type": "ImageObject",
        "url": "https://mihirshah.tech/logo.png"
      }
    },
    "datePublished": post.date,
    "dateModified": post.modifiedDate || post.date,
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": `https://mihirshah.tech/blog/${post.id}`
    },
    "url": `https://mihirshah.tech/blog/${post.id}`,
    "wordCount": post.content ? post.content.length / 6 : 1000, // Rough estimate
    "timeRequired": post.readTime || "10 min",
    "keywords": post.tags ? post.tags.join(", ") : "cybersecurity, cloud security, OWASP",
    "about": post.tags?.map(tag => ({
      "@type": "Thing",
      "name": tag
    })) || [],
    "articleSection": "Cybersecurity",
    "inLanguage": "en-US",
    "isAccessibleForFree": true
  };

  return (
    <>
      <SEO
        title={`${post.title} - Mihir Shah Blog`}
        description={post.excerpt}
        keywords={
          post.tags
            ? post.tags.join(", ")
            : "cloud security, OWASP, cybersecurity"
        }
        url={`https://mihirshah.tech/blog/${post.id}`}
        type="article"
        section="Technology"
        tags={post.tags || []}
        publishedTime={post.date}
        modifiedTime={post.modifiedDate || post.date}
        structuredData={blogPostStructuredData}
        image={post.image || "https://mihirshah.tech/og-image.jpg"}
      />
      <BlogPost post={post} onBack={handleBackToList} />
    </>
  );
};

export default BlogPostPage; 